var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-strength-meter",class:{ mounted: _vm.mounted }},[_c('div',{staticClass:"password-strength-meter--fill",attrs:{"data-score":_vm.score}})])
}
var staticRenderFns = []

export { render, staticRenderFns }